import client from '../httpClient';

const getProductsApi = (params) => {
  return client.get('/common/sites/', { params });
};

export default getProductsApi;
